import token, { tokenToVars } from '../token';
import Collapse from './collapse';

export { Collapse };
export default tokenToVars(Collapse, token);
